import { render, staticRenderFns } from "./temporary_display.vue?vue&type=template&id=363eec52&scoped=true&"
import script from "./temporary_display.vue?vue&type=script&lang=js&"
export * from "./temporary_display.vue?vue&type=script&lang=js&"
import style0 from "./temporary_display.vue?vue&type=style&index=0&id=363eec52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363eec52",
  null
  
)

export default component.exports